import { createQueryKey } from '../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../query/types';

const familiesKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
    id: <U extends QueryKeyParam>(id: U) =>
      createQueryKey({
        all: [...keys, id] as const,
      }),
    users: <U extends QueryKeyParam>(userId: U) =>
      createQueryKey({
        all: [...keys, userId] as const,
      }),
  });

const individualsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
  });

const directoryKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
    families: familiesKeys([...keys, 'families'] as const),
    individuals: individualsKeys([...keys, 'individuals'] as const),
  });

const organizationKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
    id: <U extends QueryKeyParam>(id: U) =>
      createQueryKey({
        all: [...keys, id] as const,
        families: familiesKeys([...keys, id, 'families'] as const),
        directory: directoryKeys([...keys, id, 'directory'] as const),
      }),
  });

const memberhubKeys = createQueryKey({
  all: ['memberhub'] as const,
  organizations: organizationKeys(['memberhub', 'organizations'] as const),
});

export { memberhubKeys };
